// import React from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';

// const LogoutButton: React.FC = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const handleLogout = () => {
//     console.log('clearing localstorage from logout button');
//     localStorage.clear();
//     if (location.pathname.includes('/customer')) {      
//       // Redirect back to the same URL; it will handle login if token missing
//       navigate(location.pathname);
//     } else {
//       // For other roles, redirect to /login
//       navigate('/restaurant/login');
//     }
//   };

//   return (
//     <button
//       onClick={handleLogout}
//       className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 mt-2"
//     >
//       Logout
//     </button>
//   );
// };

// export default LogoutButton;


import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const LogoutButton: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    console.log('clearing localstorage from logout button');
    localStorage.clear();
    if (location.pathname.includes('/customer')) {      
      // Redirect back to the same URL; it will handle login if token missing
      navigate(location.pathname);
    } else {
      // For other roles, redirect to /login
      navigate('/restaurant/login');
    }
  };

  // --- START OF NEW STYLES ---

  // Custom CSS for the Apple-like 3D Orange Gradient
  const appleOrange3DStyle = {
    // Orange 400-500 gradient (from top to bottom or top-left to bottom-right)
    backgroundImage: 'linear-gradient(135deg, #fb923c 0%, #ea580c 100%)', 
    
    // Subtle white highlight for the 'glassy' or 'smooth' effect
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.4), 0 2px 5px rgba(0,0,0,0.2)',
    
    // Deeper orange border/bottom shadow for the 3D 'lift'
    borderBottom: '3px solid #c2410c', 
    
    // Transition for a smooth hover/press effect
    transition: 'all 0.1s ease-out',
  };

  // Hover/Active styles for the 'press' effect
  const activeStyle = {
      // Moves the button down and removes the bottom border to simulate pressing
      transform: 'translateY(1px)',
      borderBottom: '1px solid #c2410c',
      boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.2), 0 1px 2px rgba(0,0,0,0.1)',
  };

  // --- END OF NEW STYLES ---

  return (
    <button
      onClick={handleLogout}
      className={`
        text-white 
        font-semibold 
        text-xs       /* Smaller font size for smart/small look */
        py-1.5        /* Small vertical padding */
        px-3          /* Small horizontal padding */
        rounded-full  /* Pill shape, common in Apple design */
        shadow-lg     /* Additional shadow for lift */
        opacity-90    /* Slight transparency */
        whitespace-nowrap 
        focus:outline-none 
        hover:opacity-100
      `}
      style={appleOrange3DStyle}
      onMouseDown={(e) => {
        // Apply the active style when the button is pressed
        Object.assign(e.currentTarget.style, activeStyle);
      }}
      onMouseUp={(e) => {
        // Revert the active style when the press is released
        Object.assign(e.currentTarget.style, appleOrange3DStyle);
      }}
      // Use the standard Tailwind hover for subtle color change/lift
      // The custom styles handle the main 3D effect
    >
      <span className="relative z-10">Logout</span>
    </button>
  );
};

export default LogoutButton;